<template v-slot:default="">
        <b-sidebar backdrop :id="'sidebar-VG'"
             right
            bg-variant="grey" :shadow="true">
            <div class="tab-pane active p-20">
                <h4 class="font-weight-bold">
                    {{ $t('lbl_EMPBE_VGSideMenu') }}
                </h4>
                <div class="d-flex">
                    <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/VisitorGuide/VG_Sample_thumb.jpg" class="w-75 mx-auto" />
                </div>
                
            </div>
        </b-sidebar>
</template>

<script>
export default{

    props:['type'],
    computed:{
    }
}
</script>